const gridletServices = angular.module('gridletServices', []);

gridletServices.service('layoutService', function($resource, config) {
  let layouts = $resource(
    config.api + 'user/layout/',
    { id: '@id' },
    {
      query: { method: 'GET', isArray: false },
      update: { method: 'PUT' },
    }
  );
  let defaultLayouts = $resource(
    config.api + 'user/layout-restore-default/',
    { id: '@id' },
    {
      restoreDefault: { method: 'PUT' },
    }
  );

  return {
    getAll: function() {
      return layouts.query().$promise;
    },
    update: function(object) {
      return layouts.update(object).$promise;
    },
    restoreDefault: function() {
      return defaultLayouts.restoreDefault().$promise;
    }
  };
});

gridletServices.service('gridletService', function($q, layoutService, $rootScope, eventService) {
  let initialized = false;
  let viewDefaults = null;

  let views = {
    dashboard: {
      selected: [],
      gridlets: [],
    },
    dashboard2: {
      selected: [],
      gridlets: [],
    },
    trains: {
      selected: [],
      gridlets: [],
    },
    analysis: {
      selected: [],
      gridlets: [],
    },
  };

  /* ---------------------------------------------------
   * Default gridlet configs set in EKE RMS
   * All the new gridlets use these default values when
   * added to a sheet.
   * ---------------------------------------------------
   */

  let fleetGridlet = {
    id: 'fleet-gridlet',
    title: 'Fleet Info',
    visible: true,
    modifiable: false,
    extendable: true,
    updateEvent: 'FLEET_STATUS',
    item: {
      sizeX: 8,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let fleetListGridlet = {
    id: 'fleet-list-gridlet',
    title: 'Fleet List',
    visible: true,
    modifiable: false,
    extendable: true,
    updateEvent: 'FLEET_STATUS',
    item: {
      sizeX: 5,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let trainStatusGridlet = {
    id: 'train-status-gridlet',
    visible: true,
    title: 'Fleet Status',
    modifiable: false,
    extendable: true,
    updateEvent: 'FLEET_STATUS',
    item: {
      sizeX: 2,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 4,
      row: null,
      col: null,
    },
  };

  let notificationGridlet = {
    id: 'notification-gridlet',
    visible: true,
    title: 'Fleet Fault Info',
    modifiable: false,
    extendable: true,
    updateEvent: 'ALARM_STATUS',
    item: {
      sizeX: 8,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let newFleetInfoGridlet = {
    id: 'new-fleet-info-gridlet',
    title: 'Fleet Info',
    visible: true,
    modifiable: false,
    extendable: true,
    updateEvent: 'FLEET_STATUS',
    item: {
      sizeX: 8,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let carListGridletVale = {
    id: 'car-list-gridlet-vale',
    title: 'Car List',
    visible: true,
    modifiable: false,
    extendable: true,
    updateEvent: 'FLEET_STATUS',
    item: {
      sizeX: 8,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };


  let trainSoftwareStatus = {
    id: 'train-software-status',
    title: 'Fleet Software Status',
    visible: true,
    modifiable: false,
    extendable: true,
    updateEvent: 'FLEET_STATUS',
    item: {
      sizeX: 10,
      sizeY: 6,
      minSizeX: 8,
      minSizeY: 3,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let carViewGridlet = {
    id: 'car-view-gridlet',
    title: 'Car View',
    visible: true,
    modifiable: false,
    extendable: true,
    updateEvent: 'FLEET_STATUS',
    item: {
      sizeX: 5,
      sizeY: 3,
      minSizeX: 5,
      minSizeY: 3,
      maxSizeY: 5,
      row: null,
      col: null,
    },
  };

  let activeEventsGridlet = {
    id: 'active-events-gridlet',
    visible: true,
    title: 'Active Events',
    modifiable: false,
    extendable: true,
    updateEvent: 'ALARM_STATUS',
    item: {
      sizeX: 8,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let historyEventsGridlet = {
    id: 'history-events-gridlet',
    visible: true,
    title: 'Event Log',
    modifiable: false,
    extendable: true,
    updateEvent: 'ALARM_STATUS',
    item: {
      sizeX: 8,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let auditEventsGridlet = {
    id: 'audit-events-gridlet',
    visible: true,
    title: 'Audit Events',
    modifiable: false,
    extendable: true,
    updateEvent: 'ALARM_STATUS',
    item: {
      sizeX: 8,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let activeEventsListGridlet = {
    id: 'active-events-list-gridlet',
    visible: true,
    title: 'Active Events',
    modifiable: false,
    extendable: true,
    updateEvent: 'ALARM_STATUS',
    item: {
      sizeX: 8,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let systemStatusGridlet = {
    id: 'system-status-gridlet',
    visible: true,
    title: 'Connection Status', // Name changed from 'System Status' for LU
    editCtrl: 'modifySystemStatusModalController',
    modifiable: false,
    extendable: true,
    updateEvent: 'SYSTEM_STATUS',
    item: {
      sizeX: 2,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 4,
      row: null,
      col: null,
    },
  };

  /* ---------------------------------------------------
   * New gridlets for Condition Monitoring
   * ---------------------------------------------------
   */

  let trainHealthGridlet = {
    id: 'train-health-gridlet',
    visible: true,
    title: 'Train Health',
    modifiable: false,
    extendable: true,
    updateEvent: 'FLEET_STATUS',
    item: {
      sizeX: 8,
      sizeY: 4,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let conditionAlertListGridlet = {
    id: 'condition-alert-list-gridlet',
    visible: true,
    title: 'Condition Notifications',
    modifiable: false,
    extendable: true,
    updateEvent: 'FLEET_STATUS',
    item: {
      sizeX: 8,
      sizeY: 6,
      minSizeX: 2,
      minSizeY: 6,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  let conditionEventListGridlet = {
    id: 'condition-event-list-gridlet',
    visible: true,
    title: 'Condition Events',
    modifiable: false,
    extendable: true,
    updateEvent: 'FLEET_STATUS',
    item: {
      sizeX: 8,
      sizeY: 3,
      minSizeX: 2,
      minSizeY: 2,
      maxSizeY: 6,
      row: null,
      col: null,
    },
  };

  eventService.on('userservice:unauthorized', function() {
    initialized = false;
  });


  function getGridlets(view, forceReload) {
    if (!view) throw new Error('view is required');

    if (forceReload) {
      initialized = false;
    }

    let deferred = $q.defer();
    if (initialized) {
      deferred.resolve(buildGridletsObject(view));
    } else {
      layoutService.getAll().then(function(data) {
        if (data.views) {
          viewDefaults = angular.copy(data.views);
          views = data.views;
          initialized = true;
          deferred.resolve(buildGridletsObject(view));
        } else {
          console.error('No layout data received. Cannot initialize layout');
        }
      });
    }
    return deferred.promise;
  }

  // the new method that first resets, then reloads
  function restoreDefaultGridlets() {
     return layoutService.restoreDefault();
  }

  function buildGridletsObject(view) {
    let copy = angular.copy(views);

    return copy[view].gridlets.filter(function(gridlet) {
      return gridlet.visible;
    });
  }

  function getParams(view, startDate, endDate) {
    if (!view) throw new Error('view is required');
    let params = {};
    if (startDate) {
      params.startDate = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd');
    } else if (getStartDate(view)) {
      params.startDate = DateTime.fromJSDate(getStartDate(view)).toFormat('yyyy-MM-dd');
    }
    if (endDate) {
      params.endDate = DateTime.fromJSDate(endDate).toFormat('yyyy-MM-dd');
    } else if (getEndDate(view)) {
      params.endDate = DateTime.fromJSDate(getEndDate(view)).toFormat('yyyy-MM-dd');
    }
    return params;
  }

  function hideGridlet(view, gridletKey) {
    views[view].gridlets = _.reject(views[view].gridlets, { key: gridletKey });
    saveLayout();
  }

  function showGridlet(view, gridletId) {
    views[view].gridlets.find(v => v.id === gridletId ).visible = true;
    saveLayout();
  }

  function addNewGridlet(view, gridletId) {
    switch (gridletId) {
      case 'train-status-gridlet':
        let trainStatusGridletObject = angular.copy(trainStatusGridlet);
        trainStatusGridletObject.key = Date.now();
        views[view].gridlets.push(trainStatusGridletObject);
        break;
      case 'fleet-gridlet':
        let fleetGridletObject = angular.copy(fleetGridlet);
        fleetGridletObject.key = Date.now();
        views[view].gridlets.push(fleetGridletObject);
        break;
      case 'fleet-list-gridlet':
        let fleetListGridletObject = angular.copy(fleetListGridlet);
        fleetListGridletObject.key = Date.now();
        views[view].gridlets.push(fleetListGridletObject);
        break;
      case 'notification-gridlet':
        let notificationGridletObject = angular.copy(notificationGridlet);
        notificationGridletObject.key = Date.now();
        views[view].gridlets.push(notificationGridletObject);
        break;
      case 'new-fleet-info-gridlet':
        let newFleetInfoGridletObject = angular.copy(newFleetInfoGridlet);
        newFleetInfoGridletObject.key = Date.now();
        views[view].gridlets.push(newFleetInfoGridletObject);
        break;
      case 'car-list-gridlet-vale':
        let carListGridletValeObject = angular.copy(carListGridletVale);
        carListGridletValeObject.key = Date.now();
        views[view].gridlets.push(carListGridletValeObject);
        break;
      case 'train-software-status':
        let trainSoftwareStatusObject = angular.copy(trainSoftwareStatus);
        trainSoftwareStatusObject.key = Date.now();
        views[view].gridlets.push(trainSoftwareStatusObject);
        break;
      case 'active-events-gridlet':
        let activeEventsGridletObject = angular.copy(activeEventsGridlet);
        activeEventsGridletObject.key = Date.now();
        views[view].gridlets.push(activeEventsGridletObject);
        break;
      case 'history-events-gridlet':
        let historyEventsGridletObject = angular.copy(historyEventsGridlet);
        historyEventsGridletObject.key = Date.now();
        views[view].gridlets.push(historyEventsGridletObject);
        break;
      case 'audit-events-gridlet':
          let auditEventsGridletObject = angular.copy(auditEventsGridlet);
          auditEventsGridletObject.key = Date.now();
          views[view].gridlets.push(auditEventsGridletObject);
          break;
      case 'active-events-list-gridlet':
        let activeEventsListGridletObject = angular.copy(activeEventsListGridlet);
        activeEventsListGridletObject.key = Date.now();
        views[view].gridlets.push(activeEventsListGridletObject);
        break;
      case 'system-status-gridlet':
        let systemStatusGridletObject = angular.copy(systemStatusGridlet);
        systemStatusGridletObject.key = Date.now();
        views[view].gridlets.push(systemStatusGridletObject);
        break;
      case 'train-health-gridlet':
        let trainHealthGridletObject = angular.copy(trainHealthGridlet);
        trainHealthGridletObject.key = Date.now();
        views[view].gridlets.push(trainHealthGridletObject);
        break;
      case 'condition-alert-list-gridlet':
        let conditionAlertListGridletObject = angular.copy(conditionAlertListGridlet);
        conditionAlertListGridletObject.key = Date.now();
        views[view].gridlets.push(conditionAlertListGridletObject);
        break;
      case 'condition-event-list-gridlet':
        let conditionEventListGridletObject = angular.copy(conditionEventListGridlet);
        conditionEventListGridletObject.key = Date.now();
        views[view].gridlets.push(conditionEventListGridletObject);
        break;
    }
    saveLayout();
  }

  function saveViewName(view, newName) {
    views[view].name = newName;
    saveLayout();
  }

  function saveGridletName(view, gridletKey, newName) {
    const found = views[view].gridlets.find(v => v.key === gridletKey );
    if (!found) {
      // The gridlet could have been deleted during editing layout so we can't rename it.
      saveLayout();
      return;
    }
    let currentName = found.title;
    if (currentName !== newName) {
      views[view].gridlets.find(v => v.key === gridletKey ).title = newName;
      saveLayout();
    }
  }

  function getHiddenGridlets(view) {
    if (!view) throw new Error('view is required');

    let deferred = $q.defer();
    let unwatch = $rootScope.$watch(
      function() {
        return initialized;
      },
      function(newVal) {
        if (newVal) {
          let copy = angular.copy(views);
          let result = _.filter(copy[view].gridlets, function(gridlet) {
            return !gridlet.visible;
          });
          deferred.resolve(result);
          unwatch();
        }
      }
    );

    return deferred.promise;
  }

  function getAllGridlets(view) {
    if (!view) throw new Error('view is required');
    return views[view].gridlets;
  }

  function saveLayout() {
    if (initialized) {
      layoutService.update({
        views: views,
      });
    }
  }

  function updateLayout(view, gridletKey, item) {
    const found = views[view].gridlets.find(g => g.key===gridletKey);
    // Gridlet might have been deleted from view.
    if (found) {
      found.item = item;
    }
  }

  function resetView(view) {
    views[view] = angular.copy(viewDefaults[view]);
    saveLayout();
  }

  let customizable = false;

  function setCustomizable(value) {
    customizable = value;
  }

  function getCustomizable() {
    return customizable;
  }

  return {
    getGridlets: getGridlets,
    restoreDefaultGridlets: restoreDefaultGridlets,
    getParams: getParams,
    hideGridlet: hideGridlet,
    getHiddenGridlets: getHiddenGridlets,
    getAllGridlets: getAllGridlets,
    showGridlet: showGridlet,
    addNewGridlet: addNewGridlet,
    saveViewName: saveViewName,
    saveGridletName: saveGridletName,
    saveLayout: saveLayout,
    updateLayout: updateLayout,
    resetView: resetView,
    setCustomizable: setCustomizable,
    getCustomizable: getCustomizable,
  };
});
